import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAccess } from '../../contexts/index';
import StaffEdit from '../../components/pages/staff/StaffEdit';

const ProtectedStaffEdit: React.FC = () => {
  const { allowedRoutes } = useAccess();

  if (!allowedRoutes.includes('/staff/edit')) {
    return <Navigate to="/staff" replace />;
  }

  return <StaffEdit />;
};

export default ProtectedStaffEdit;
